import React from 'react';
import './ReceiptPrint.scss';

const iskenderunLogo = '/assets/images/logo.png'; 

const ReceiptPrint = ({ data }) => {
    if (!data) return null;

    const {
        transactionId,
        amount,
        createdAt,
        referenceId,
        paymentGroup,
        firstName,
        lastName,
        identityNumber,
        taxNumber,
        message,
        appointmentId
    } = data;

    // Fatura detaylarını biçimlendir
    const displayAmount = amount ? Number(amount).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' }) : '-';
    const displayDate = createdAt ? new Date(createdAt).toLocaleString('tr-TR') : new Date().toLocaleString('tr-TR');

    const printTime = new Date().toLocaleString('tr-TR', {
        day: '2-digit', month: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit'
    });

    return (
        <div id="print-receipt" className="receipt-print-wrapper">
            <div className="receipt-container">
                {/* Otomatik tarayıcı bilgisini sildiğimiz için biz ekliyoruz */}
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', color: '#555', marginBottom: '20px' }}>
                    <span>{printTime}</span>
                    <span>İskenderun Belediyesi</span>
                </div>

                <div className="receipt-header">
                    <img src={iskenderunLogo} alt="İskenderun Belediyesi" className="receipt-logo" />
                    <h2>T.C. İSKENDERUN BELEDİYESİ</h2>
                    <h3>Tahsilat Makbuzu / Dekont</h3>
                </div>

                <div className="receipt-body">
                    <div className="receipt-row">
                        <span className="label">İşlem Numarası:</span>
                        <span className="value">{transactionId}</span>
                    </div>

                    <div className="receipt-row">
                        <span className="label">İşlem Tarihi:</span>
                        <span className="value">{displayDate}</span>
                    </div>

                    {(firstName || lastName) && (
                        <div className="receipt-row">
                            <span className="label">Müşteri / Kurum Adı:</span>
                            <span className="value">{firstName} {lastName}</span>
                        </div>
                    )}

                    {taxNumber && (
                        <div className="receipt-row">
                            <span className="label">Vergi Numarası:</span>
                            <span className="value">{taxNumber}</span>
                        </div>
                    )}

                    {identityNumber && !taxNumber && (
                        <div className="receipt-row">
                            <span className="label">T.C. Kimlik No:</span>
                            <span className="value">{identityNumber}</span>
                        </div>
                    )}

                    <div className="receipt-row">
                        <span className="label">Ödenen Tutar:</span>
                        <span className="value amount">{displayAmount}</span>
                    </div>

                    {appointmentId && (
                        <div className="receipt-row">
                            <span className="label">Randevu / Başvuru No:</span>
                            <span className="value">{appointmentId}</span>
                        </div>
                    )}

                    {message && (
                        <div className="receipt-row highlight">
                            <span className="label">Açıklama:</span>
                            <span className="value">{message}</span>
                        </div>
                    )}

                    {referenceId && paymentGroup === 'CardTopUp' && (
                        <div className="receipt-row">
                            <span className="label">Yükleme Yapılan Kart No:</span>
                            <span className="value">{referenceId}</span>
                        </div>
                    )}

                    <div className="receipt-row">
                        <span className="label">Ödeme Modeli:</span>
                        <span className="value">Online Ödeme</span>
                    </div>
                </div>

                <div className="receipt-footer">
                    <p className="system-note">Sistemden otomatik olarak üretilmiştir. (İlgili Sanal POS tahsilat onayıdır.)</p>
                </div>
            </div>
        </div>
    );
};

export default ReceiptPrint;
